import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { DashboardIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/payment-management/overview')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="paymentManagement.sidebar.menu.overview" icon={DashboardIcon} />,
      title: <Translation id="paymentManagement.sidebar.menu.overview" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
